export const resourceUsageChart = (data = []) => {
  const timestamps = data.map(d => d.timestamp);

  return {
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'cross' }
    },
    legend: {
      data: ['CPU %', 'Memory %', 'Connections'],
      bottom: 0
    },
    grid: {
      left: '3%',
      right: '4%',
      top: '10%',
      bottom: '12%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: timestamps,
      boundaryGap: false,
      axisLabel: { fontSize: 10 }
    },
    yAxis: [
      {
        type: 'value',
        name: '%',
        max: 100,
        axisLabel: { fontSize: 10, formatter: '{value}%' }
      },
      {
        type: 'value',
        name: 'Count',
        axisLabel: { fontSize: 10 }
      }
    ],
    series: [
      {
        name: 'CPU %',
        type: 'line',
        smooth: true,
        showSymbol: false,
        data: data.map(d => d.cpu ?? 0),
        itemStyle: { color: '#13c2c2' },
        lineStyle: { width: 2 }
      },
      {
        name: 'Memory %',
        type: 'line',
        smooth: true,
        showSymbol: false,
        data: data.map(d => d.memory ?? 0),
        itemStyle: { color: '#eb2f96' },
        lineStyle: { width: 2 }
      },
      {
        name: 'Connections',
        type: 'line',
        smooth: true,
        showSymbol: false,
        yAxisIndex: 1,
        data: data.map(d => d.connections ?? 0),
        itemStyle: { color: '#fa8c16' },
        lineStyle: { width: 2, type: 'dashed' }
      }
    ]
  };
};
